import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueAnalytics from 'vue-analytics'

import './assets/css/tailwind.css'
import 'material-icons/iconfont/material-icons.css'
import './assets/styles/index.scss'

import VeeValidate from '@/plugins/VeeValidate'
import AppComponents from '@/plugins/AppComponents'
import Notifications from 'vue-notification'
import vueCountryRegionSelect from 'vue-country-region-select'

Vue.config.productionTip = false

function loadApp () {
	Vue.use(VeeValidate)
}
Vue.use(vueCountryRegionSelect)
Vue.use(Notifications)
Vue.use(AppComponents)

/*
Vue.use(VueAnalytics, {
  id: 'UA-196212706-1',
  ecommerce: {
    enabled: true,
    enhanced: true
  },
  router
})
*/

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

loadApp()
